import { normalizeText, replaceText } from "./domUtils";

export const improveEmployeeFileTrashLabels = () => {
  document.querySelectorAll("option, td").forEach((element) => {
    if (normalizeText(element.textContent) === "employee_file") {
      replaceText(element, "Arquivos de colaboradores");
    }
  });
};
